import React, { useState } from "react";
import { Card, Modal } from "react-bootstrap";
import { socialMedia } from "../../../asset/json/CardDetail";
import CloudSocial from "../../../asset/image/CloudSocialLogo.svg";
import "./media.scss";
import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";
import "react-alice-carousel/lib/scss/alice-carousel.scss";
import { CardActionArea } from "@material-ui/core";

const responsive = {
  0: {
    items: 1,
  },
  550: {
    items: 2,
  },
  768: {
    items: 2,
  },
  1000: {
    items: 3,
  },
  1200: {
    items: 4,
  },
  1920: {
    items: 4,
  },
};

export function Media() {
  const [show, setShow] = useState(false);
  const [video, setVideo] = useState("");
  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
  };
  return (
    <div className="media" id="video">
      <div className="back-card">
        <Card className="c-card">
          <Card.Body className="c-body">
            <Card.Title className="c-title">
              Manage all your Social Media from One Place
            </Card.Title>
            <Card.Text className="c-desc">
              Control multiple social accounts simultaneously, engage with
              several prospects at the same time, and provide superior customer
              experience.
            </Card.Text>
          </Card.Body>
        </Card>
      </div>
      <AliceCarousel
        mouseTracking
        className="carousel-card"
        infinite
        autoPlay
        autoPlayInterval="2000"
        responsive={responsive}
      >
        {socialMedia.map(({ img, title, desc, listen, imgUrl, id }) => (
          <Card className="card-cover" key={id} id="video">
            <Card.Body>
              <div className="card-box">
                <Card.Img
                  variant=""
                  src={img}
                  className="card-icon"
                  alt={title}
                />
                <Card.Title className="c-title">{title}</Card.Title>
              </div>
              <Card.Img
                className="card-video"
                variant=""
                src={imgUrl}
                alt={title}
                height="170"
                width="100"
                onClick={() => {
                  handleShow();
                  setVideo(listen);
                }}
              />
              <Modal
                size="xl"
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                centered
              >
                <Modal.Header className="modelHeader" closeButton>
                  <img
                    src={CloudSocial}
                    alt="CloudSocial"
                    className="modalLogo"
                  />
                </Modal.Header>
                <Modal.Body className="model-body">
                  <div
                    className="video"
                    style={{
                      position: "relative",
                      paddingBottom: "56.25%",
                      paddingTop: "25",
                      height: "0",
                      wrapAround: true,
                      cursor: "pointer",
                      freeScroll: true,
                    }}
                  >
                    <iframe
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                      }}
                      src={video}
                      frameBorder="0"
                      title="CloudSocial"
                    />
                  </div>
                </Modal.Body>
              </Modal>
              <Card.Text className="card-desc">{desc}</Card.Text>
              <hr className="card-divider" />
            </Card.Body>
          </Card>
        ))}
      </AliceCarousel>
    </div>
  );
}
